import React, { useState, useMemo } from "react"
import _ from "lodash";
import { Button } from "@jutro/components";
import { DropdownMenuLink } from '@jutro/router';

import { DisplayColumn, Table } from '@jutro/legacy/datatable';
import { Flex, FlexItem } from '@jutro/layout';
import { useTranslator } from '@jutro/locale';
import { ProductUtil } from 'wnice-portals-util-react';
import messages from './PropertyIncidents.messages'
import SinglePropertyIncident from "./SinglePropertyIncident/SinglePropertyIncident";
import { getFullAddressDisplayName } from "../util/AddressUtil";

import { ToggleField, DropdownMenuButton } from '@jutro/legacy/components';

const PropertyIncidentQuestionValue = {
    Yes: 'Yes',
    No: 'No'
}

const AddNewLocation = 'AddNewLocation';

const propertyIncidentInitValue = {
    belongsToInsured_Ext: false
}

const {
    RT_LOB_NAME,
    WT_LOB_NAME
} = ProductUtil;

const PropertyIncidents = (props) => {
    const {
        propertyIncidents = [],
        predefinedLossLocations,
        incidentsAddresses,
        LOB_NAME,
        propertyOwnerContacts,
        savePropertyIncident,
        removePropertyIncident
    } = props;

    const translator = useTranslator();

    const [propertyIncidentQuestionValue, setPropertyIncidentQuestion] = useState(() => {
        return propertyIncidents.length > 0 ? PropertyIncidentQuestionValue.Yes : PropertyIncidentQuestionValue.No
    })
    const [singlePropertyIncidentPopupStatus, setSinglePropertyIncidentPopupStatus] = useState({
        isOpen: false,
        originPropertyIncident: propertyIncidentInitValue,
        editingPropertyIncidentIndex: undefined
    })

    const closePopup = () => {
        setSinglePropertyIncidentPopupStatus({
            isOpen: false,
            originPropertyIncident: propertyIncidentInitValue,
            editingPropertyIncidentIndex: undefined
        })
    }

    const onPopupCancel = () => {
        closePopup()
    }

    const onPopupSave = async (propertyIncident) => {
        await savePropertyIncident(propertyIncident)
        closePopup()
    }

    const onAddPropertyIncident = () => {
        const newPropertyLocation = {
            country: 'US' ,
            publicID: AddNewLocation
        };
        const newPropertyIncident = {
            locationPublicID_Ext: AddNewLocation,
            location_Ext: newPropertyLocation
        };
        setSinglePropertyIncidentPopupStatus({
            isOpen: true,
            originPropertyIncident: newPropertyIncident
        })
    }

    const onEditPropertyIncident = (item, index) => {
        setSinglePropertyIncidentPopupStatus({
            isOpen: true,
            originPropertyIncident: item,
            editingPropertyIncidentIndex: index
        })
    }

    const PropertyQuestionLabel = useMemo(() => {
        switch (LOB_NAME) {
            case WT_LOB_NAME:
                return translator(messages.PropertyIncidentsQuestionWT);
            case RT_LOB_NAME:
                return translator(messages.PropertyIncidentsQuestionRT);
            default:
                return translator(messages.PropertyIncidentsQuestion);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return <>
        <ToggleField
            id='propertyIncidentQuestion'
            label={PropertyQuestionLabel}
            labelPosition='left'
            availableValues={[
                {
                    code: PropertyIncidentQuestionValue.Yes,
                    name: translator(messages.Yes)
                },
                {
                    code: PropertyIncidentQuestionValue.No,
                    name: translator(messages.No)
                }
            ]}
            onValueChange={(value) => {
                setPropertyIncidentQuestion(value)
            }}
            disabled={propertyIncidents.length > 0}
            value={propertyIncidentQuestionValue}
        />
        {propertyIncidentQuestionValue === PropertyIncidentQuestionValue.Yes &&
            <>
                <Flex
                    id="propertyFlexButton"
                    justifyContent="right"
                >
                    <FlexItem>
                        <Button
                            variant="primary"
                            icon="gw-add"
                            onClick={onAddPropertyIncident}
                            disabled={singlePropertyIncidentPopupStatus.isOpen}
                            label={translator(messages.AddProperty)}
                        />
                    </FlexItem>
                </Flex>
                <Table
                    data={propertyIncidents.map((e, index) => ({...e, number: index + 1}))}
                >
                    <DisplayColumn
                        id="propertySectionIDColumn"
                        header={translator(messages.Number)}
                        path="number"
                        textAlign='center'
                    />
                    <DisplayColumn
                        id="propertyLocationColumn"
                        header={translator(messages.PropertyLocation)}
                        // path="location_Ext.displayName"
                        textAlign='center'
                        renderCell = {(item) => {
                            const addressPublicID = _.get(item, 'locationPublicID_Ext')
                            const allAddresses = predefinedLossLocations.concat(incidentsAddresses)
                            const matchedAddress = allAddresses.find((address) => address.publicID === addressPublicID)
                            return getFullAddressDisplayName(matchedAddress)
                        }}
                    />
                    <DisplayColumn
                        id="actionColumn"
                        textAlign='right'
                        renderCell={(item, index) => {
                            return <DropdownMenuButton
                                id={`DropdownMenuBtn_${index}`}
                                icon="gw-expand-more"
                                size="small"
                                iconPosition="right"
                                disabled={singlePropertyIncidentPopupStatus.isOpen}
                            >
                                <DropdownMenuLink
                                    icon="gw-edit"
                                    iconPosition="left"
                                    onClick={() => onEditPropertyIncident(item, index)}
                                >
                                    {translator(messages.Edit)}
                                </DropdownMenuLink>
                                <DropdownMenuLink
                                    icon="gw-delete"
                                    iconPosition="left"
                                    onClick={() => removePropertyIncident(propertyIncidents[index])}
                                >
                                    {translator(messages.Delete)}
                                </DropdownMenuLink>
                            </DropdownMenuButton>
                        }}
                    />
                </Table>
                {singlePropertyIncidentPopupStatus.isOpen && <SinglePropertyIncident
                    originPropertyIncident={singlePropertyIncidentPopupStatus.originPropertyIncident}
                    editingPropertyIncidentIndex={singlePropertyIncidentPopupStatus.editingPropertyIncidentIndex}
                    onPopupCancel={onPopupCancel}
                    onPopupSave={onPopupSave}
                    predefinedLossLocations={predefinedLossLocations}
                    incidentsAddresses={incidentsAddresses}
                    propertyOwnerContacts={propertyOwnerContacts}
                />}
            </>
        }
        
    </>
}

export default PropertyIncidents
